// Vuex 4 for Vue 3
import { createStore } from 'vuex'

// ถ้ามี modules แยกไฟล์ไว้ ก็ import มาตรงนี้
// import auth from './modules/auth'
// import settings from './modules/settings'

export default createStore({
  state: () => ({
    // ใส่ state เริ่มต้นของคุณที่นี่
  }),
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    // auth,
    // settings,
  },
})
